import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import portalT from '../translations/portal';
import axios from 'axios';
import { ArrowLeft, Sparkles, Loader } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import ExportPDFButton from '../components/ExportPDFButton';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

const RoadmapCreator = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const { lang } = useLanguage();
  const t = portalT[lang];
  const tp = t.toolPages.roadmap;

  const [formData, setFormData] = useState({
    company_name: '', industry: '', current_challenges: '', goals: '',
    timeline: '6 months', budget_range: '€10,000 - €50,000',
  });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/tools/roadmap-creator`, formData, { headers: { Authorization: `Bearer ${token}` } });
      setResult(res.data);
    } catch (error) {
      alert('Error: ' + (error.response?.data?.detail || error.message));
    } finally { setLoading(false); }
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const timelineOpts = lang === 'nl'
    ? [['3 months','3 maanden'],['6 months','6 maanden'],['1 year','1 jaar'],['2 years','2 jaar']]
    : [['3 months','3 months'],['6 months','6 months'],['1 year','1 year'],['2 years','2 years']];

  return (
    <div className="tool-page">
      <div className="tool-header">
        <button onClick={() => navigate('/portal/ai-tools')} className="btn-secondary" data-testid="back-btn"><ArrowLeft size={16} /> {t.common.aiTools}</button>
        <h1 className="heading-1" data-testid="roadmap-title">{tp.title}</h1>
      </div>
      <div className="tool-content">
        {!result ? (
          <div className="tool-form-container">
            <div className="tool-intro"><Sparkles size={32} /><h2 className="heading-2">{tp.intro}</h2><p className="body-medium text-secondary">{tp.introDesc}</p></div>
            <form onSubmit={handleSubmit} className="tool-form">
              <div className="form-group"><label className="body-small">{tp.companyName}</label><input type="text" name="company_name" value={formData.company_name} onChange={handleChange} required className="form-input" placeholder={tp.companyPlaceholder} data-testid="input-company" /></div>
              <div className="form-group"><label className="body-small">{tp.industry}</label><input type="text" name="industry" value={formData.industry} onChange={handleChange} required className="form-input" placeholder={tp.industryPlaceholder} data-testid="input-industry" /></div>
              <div className="form-group"><label className="body-small">{tp.challenges}</label><textarea name="current_challenges" value={formData.current_challenges} onChange={handleChange} required rows="4" className="form-input" placeholder={tp.challengesPlaceholder} data-testid="input-challenges" /></div>
              <div className="form-group"><label className="body-small">{tp.goals}</label><textarea name="goals" value={formData.goals} onChange={handleChange} required rows="4" className="form-input" placeholder={tp.goalsPlaceholder} data-testid="input-goals" /></div>
              <div className="form-row">
                <div className="form-group"><label className="body-small">{tp.timeline}</label><select name="timeline" value={formData.timeline} onChange={handleChange} className="form-input" data-testid="select-timeline">{(Array.isArray(timelineOpts) ? timelineOpts : []).map(([v,l]) => <option key={v} value={v}>{l}</option>)}</select></div>
                <div className="form-group"><label className="body-small">{tp.budget}</label><select name="budget_range" value={formData.budget_range} onChange={handleChange} className="form-input" data-testid="select-budget"><option value="€5,000 - €10,000">€5.000 - €10.000</option><option value="€10,000 - €50,000">€10.000 - €50.000</option><option value="€50,000 - €100,000">€50.000 - €100.000</option><option value="€100,000+">€100.000+</option></select></div>
              </div>
              <button type="submit" disabled={loading} className="btn-primary submit-btn" data-testid="submit-btn">{loading ? <><Loader className="spin" size={16} /> {tp.generating}</> : <><Sparkles size={16} /> {tp.generate}</>}</button>
            </form>
          </div>
        ) : (
          <div className="tool-result">
            <div className="result-header"><h2 className="heading-2">{tp.resultTitle}</h2><div style={{display:'flex',gap:'0.5rem'}}><ExportPDFButton title={tp.resultTitle} content={result.roadmap} toolName={tp.title} /><button onClick={() => setResult(null)} className="btn-secondary" data-testid="new-roadmap-btn">{tp.createNew}</button></div></div>
            <div className="result-content markdown-content"><ReactMarkdown>{result.roadmap}</ReactMarkdown></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoadmapCreator;
